module.exports = __webpack_public_path__ + "static/media/manwani ji_page-0001.392b63e8.jpg";